<template>
  <esg-base-dashboard-card :title="`${corporation.name ? corporation.name : '법인'} 에너지 사용량`">
    <template #actions>
      <b-row>
        <b-col cols="auto">
          <esg-base-select-box size="sm"
                               label="법인"
                               v-model="corporationCode"
                               :options="corporations"/>
        </b-col>
        <!-- 23-10-11 윤지원: 문경태 팀장님의 요청에 의해 정렬기능 삭제 -->
<!--         <b-col cols="auto">-->
<!--           <esg-base-select-box v-model="sort"-->
<!--                                label="정렬"-->
<!--                                size="sm">-->
<!--             <option value="asc">오름차순</option>-->
<!--             <option value="desc">내림차순</option>-->
<!--           </esg-base-select-box>-->
<!--         </b-col>-->
      </b-row>
    </template>
    <corp-energy-by-fuel :corporation="corporation"
                         :sort="sort"/>
  </esg-base-dashboard-card>

</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import CorpEnergyByFuel from "@/components/esg/3. Monitoring/charts2/CorpEnergyByFuel.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: 'EnterpriseConsumptionByEnergy',
  components: { EsgBaseSelectBox, CorpEnergyByFuel, EsgBaseDashboardCard, },
  data() {
    return {
      corporationCode: '',
      corporations: [],
      businessLocations: [],
      sort: 'desc',
    }
  },
  computed: {
    corporation() {
      if (!this.corporationCode)
        return {}
      return this.corporations.find(corp => corp.code === this.corporationCode);
    }
  },
  created() {
    this.fetchCorps();
  },
  methods: {
    async fetchCorps() {
      try {
        let response = await axios.get('esg/lca/tables/esg_base_corporation', {
          headers: { Authorization: accessToken() },
        });

        // Add value and text to use data as select options
        response.data.list.forEach(corp => {
          corp.value = corp.code;
          corp.text = corp.name;
        });

        this.corporations = response.data.list;

        // Set default
        this.corporationCode = this.corporations[0].code;
      } catch (error) {
        await this.showError(error);
      }
    },
  }
}
</script>
<style scoped>
>>> {
  font-family: NanumGothic;
}
</style>